import { createContext } from "react";

// True inside a Table header cell. An info `Tooltip` embedded in a column
// header reads this to render its bubble compact (sized to the small uppercase
// header text) and centered, instead of the default md medallion that sits
// oversized and low next to the header label.
export const TableHeaderContext = createContext(false);
